import { Fragment } from "react";
import { Reveal } from "@/components/Reveal";
import { SeedOrnament } from "@/components/Dandelion";

const BEATS = [
  {
    n: "01",
    title: "Lukning / Beskyttelse",
    text: "Vi tænker ikke, at der er noget galt med mælkebøtten, når den lukker sig. Vi forstår det som en respons på de betingelser, den befinder sig i.",
    img: "/brand/phase-lukning.png",
    id: "lukning",
  },
  {
    n: "02",
    title: "Spredning",
    text: "Ord, forståelser og narrativer spreder og forplanter sig. De kan fastholde fortællinger – eller åbne for nye forståelser og muligheder.",
    img: "/brand/phase-spredning.png",
    id: "spredning",
  },
  {
    n: "03",
    title: "Frø",
    text: "Undervisning kan skabe frø. Ny viden, nye perspektiver og et fælles sprog kan sætte noget i bevægelse.",
    img: "/brand/phase-froe.png",
    id: "froe",
  },
  {
    n: "04",
    title: "Grobund / Ny vækst",
    text: "Implementering skaber grobund. Varig udvikling kræver rammer, relationer og praksisser, hvor ny viden kan slå rod.",
    img: "/brand/phase-grobund.png",
    id: "grobund-vaekst",
  },
];

const Arrow = () => (
  <svg
    viewBox="0 0 44 12"
    className="mx-auto w-10 shrink-0 rotate-90 lg:mt-10 lg:rotate-0"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M2 6 H38 M32 1.5 L38.5 6 L32 10.5"
      stroke="#B46A45"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.75"
    />
  </svg>
);

const Story = () => (
  <section id="grobund" data-testid="story-section" className="scroll-mt-24 px-6 py-28 lg:py-40">
    <div className="mx-auto max-w-6xl">
      <Reveal className="text-center">
        <h2 className="font-serif text-3xl text-[#3F5A47] sm:text-4xl lg:text-5xl">
          Udvikling kræver grobund
        </h2>
        <div className="mx-auto mt-7 h-px w-16 bg-[#3F5A47]" />
      </Reveal>
      <div className="mt-24 flex flex-col gap-20 lg:mt-32 lg:flex-row lg:items-start lg:gap-5">
        {BEATS.map((beat, i) => (
          <Fragment key={beat.id}>
            <Reveal
              delay={i * 0.12}
              className="flex-1 text-center"
            >
              <div data-testid={`story-beat-${beat.id}`}>
                <div className="flex h-20 items-end justify-center">
                  <img src={beat.img} alt="" className="mx-auto h-14 w-auto sm:h-20" />
                </div>
                <h3 className="mt-9 font-serif text-xl text-[#3F5A47] sm:text-2xl">{beat.title}</h3>
                <p className="mx-auto mt-5 max-w-xs text-sm leading-relaxed text-[#2F3338]/80">
                  {beat.text}
                </p>
              </div>
            </Reveal>
            {i < BEATS.length - 1 && <Arrow />}
          </Fragment>
        ))}
      </div>
      <Reveal className="mt-28 text-center lg:mt-40" data-testid="story-highlight">
        <SeedOrnament className="mx-auto mb-10 w-14" />
        <p className="font-serif text-3xl leading-snug text-[#2F3338] sm:text-4xl lg:text-5xl">
          Undervisning kan skabe <span className="text-[#3F5A47]">frø</span>.
        </p>
        <p className="mt-5 font-serif text-3xl leading-snug text-[#2F3338] sm:text-4xl lg:text-5xl">
          Implementering skaber <span className="text-[#B46A45]">grobund</span>.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Story;
